import { ReactComponent as Loader } from "../assets/loader.svg";
import { ReactComponent as Checkmark } from "../assets/checkmark.svg";
import { __ } from "@wordpress/i18n";
import { useContext } from "react";
import { SettingsContext } from "../Settings";

const SaveSettingsButton = () => {
  const { formSubmitting, requestSuccess } = useContext(SettingsContext);

  return (
    <button type={"submit"} className="sby-btn sb-btn-orange">
      <span>
        {formSubmitting && <Loader />}
        {requestSuccess && <Checkmark />}
      </span>
      {__("Save Changes", "feeds-for-youtube")}
    </button>
  );
};

export default SaveSettingsButton;
